import { useAuth } from '../contexts/AuthContext';

/**
 * Custom hook to check user permissions based on role
 * Handles case-insensitive role comparison and provides safe defaults
 */
export const usePermissions = () => {
  const { user } = useAuth();

  // Normalize role to lowercase for comparison (handles 'Manager', 'MANAGER', 'manager', etc.)
  const normalizedRole = user?.role?.toLowerCase() || '';

  // Debug log (remove in production)
  if (user && process.env.NODE_ENV === 'development') {
    console.log('[usePermissions] User role:', user.role, '| Normalized:', normalizedRole);
  }

  const permissions = {
    // Check if user can delete resources (Admin only)
    canDelete: normalizedRole === 'admin',
    
    // Check if user can download files (Admin and Manager)
    canDownload: normalizedRole === 'admin' || normalizedRole === 'manager',
    
    // Check if user can edit resources (Admin and Manager)
    canEdit: normalizedRole === 'admin' || normalizedRole === 'manager',
    
    // Check if user can create resources (Admin and Manager)
    canCreate: normalizedRole === 'admin' || normalizedRole === 'manager',
    
    // Check if user is admin
    isAdmin: normalizedRole === 'admin',
    
    // Check if user is manager
    isManager: normalizedRole === 'manager',
    
    // Check if user is viewer
    isViewer: normalizedRole === 'viewer',
    
    // Get user role (original, not normalized)
    role: user?.role || null,
  };

  return permissions;
};
